import _ from 'underscore';
import Analytics from './analytics';
import Vast from '../../edit/model/vast';
import xtend from 'xtend';
import S from 'pull-stream';
import flatMerge from 'pull-flat-merge';
var DATE_FORMAT = 'YYYY-MM-DD';
var formatDate = _.partial(require('date-fns/format'), _, DATE_FORMAT);
import startOfWeek from 'date-fns/start_of_week';
import lastDayOfWeek from 'date-fns/last_day_of_week';
import startOfMonth from 'date-fns/start_of_month';
import endOfMonth from 'date-fns/end_of_month';


function defaultQuery (state) {
    return { campaignID: state.vast.data.campaignID };
}

var quickFilters = {
    today: _.constant({
        startDate: formatDate(new Date()),
        endDate: formatDate(new Date())
    }),

    thisWeek: _.constant({
        startDate: formatDate(startOfWeek(new Date())),
        endDate: formatDate(lastDayOfWeek(new Date()))
    }),

    thisMonth: _.constant({
        startDate: formatDate(startOfMonth(new Date())),
        endDate: formatDate(endOfMonth(new Date()))
    }),

    forever: function (state) {
        return {
            startDate: state.vast.data.startDate,
            endDate: state.vast.data.endDate || formatDate(new Date())
        };
    }
};

function CreateAnalyticsModel (api) {
    var analytics = Analytics(api);
    var vast = Vast(api);

    // @TODO make this nicer
    // Event.path(['analytics', 'get']) method
    function fetchAnalytics (state, msg, ev) {
        // set `query` when we get a response
        return S(
            analytics.effects.get(state, msg, ev),
            S.map(function (ev) {
                return ev[1][0] === 'get' ?
                    S(
                        S.values([
                            ev,
                            ['setQuery', {
                                startDate: ev[1][1].meta.resultsStartDate,
                                endDate: ev[1][1].meta.resultsStartEnd
                            }]
                        ])
                    ) :
                    S.once(ev)
                ;
            }),
            flatMerge()
        );
    }

    function AnalyticsModel () {
        return {
            query: {
                startDate: null,
                endDate: null
            },
            sortTableBy: 'asset',
            sortTableAsc: false,
            analytics: analytics(),
            vast: vast(),
            resolving: []
        };
    }

    AnalyticsModel.effects = {
        submitQuery: function (state, msg, ev) {
            var query = state.query.startDate ?
                xtend(defaultQuery(state), state.query) :
                defaultQuery(state)
            ;

            return fetchAnalytics(state.analytics, msg.analytics, query);
        },

        quickFilter: function (state, msg, ev) {
            var query = xtend(defaultQuery(state), quickFilters[ev](state));
            return fetchAnalytics(state.analytics, msg.analytics, query);
        },

        analytics: xtend(analytics.effects, {
            get: fetchAnalytics
        }),

        vast: vast.effects
    };

    AnalyticsModel.update = {
        setQuery: function (state, ev) {
            return xtend(state, {
                query: xtend(state.query, ev)
            });
        },
        sortTable: function (state, ev) {
            return xtend(state, {
                sortTableBy: ev,
                sortTableAsc: state.sortTableBy === ev ?
                    !state.sortTableAsc :
                    false
            });
        },
        analytics: analytics.update,
        vast: vast.update
    };

    return AnalyticsModel;
}

export default CreateAnalyticsModel;
